/* eslint-disable */
import _m0 from "protobufjs/minimal";
import { TransPb } from "../../../../gen/body/trans";

export const protobufPackage = "skills";

/** Arguments for update dock location */
export interface UpdateDockLocationActionArgs {
  navTUpdatedDock: TransPb | undefined;
}

export interface UpdateDockLocationActionResultData {
}

export interface UpdateDockLocationActionStateData {
}

function createBaseUpdateDockLocationActionArgs(): UpdateDockLocationActionArgs {
  return { navTUpdatedDock: undefined };
}

export const UpdateDockLocationActionArgs = {
  encode(message: UpdateDockLocationActionArgs, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    if (message.navTUpdatedDock !== undefined) {
      TransPb.encode(message.navTUpdatedDock, writer.uint32(10).fork()).ldelim();
    }
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateDockLocationActionArgs {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateDockLocationActionArgs();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1:
          if (tag !== 10) {
            break;
          }

          message.navTUpdatedDock = TransPb.decode(reader, reader.uint32());
          continue;
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): UpdateDockLocationActionArgs {
    return { navTUpdatedDock: isSet(object.navTUpdatedDock) ? TransPb.fromJSON(object.navTUpdatedDock) : undefined };
  },

  toJSON(message: UpdateDockLocationActionArgs): unknown {
    const obj: any = {};
    if (message.navTUpdatedDock !== undefined) {
      obj.navTUpdatedDock = TransPb.toJSON(message.navTUpdatedDock);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateDockLocationActionArgs>, I>>(base?: I): UpdateDockLocationActionArgs {
    return UpdateDockLocationActionArgs.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateDockLocationActionArgs>, I>>(object: I): UpdateDockLocationActionArgs {
    const message = createBaseUpdateDockLocationActionArgs();
    message.navTUpdatedDock = (object.navTUpdatedDock !== undefined && object.navTUpdatedDock !== null)
      ? TransPb.fromPartial(object.navTUpdatedDock)
      : undefined;
    return message;
  },
};

function createBaseUpdateDockLocationActionResultData(): UpdateDockLocationActionResultData {
  return {};
}

export const UpdateDockLocationActionResultData = {
  encode(_: UpdateDockLocationActionResultData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateDockLocationActionResultData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateDockLocationActionResultData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateDockLocationActionResultData {
    return {};
  },

  toJSON(_: UpdateDockLocationActionResultData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateDockLocationActionResultData>, I>>(
    base?: I,
  ): UpdateDockLocationActionResultData {
    return UpdateDockLocationActionResultData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateDockLocationActionResultData>, I>>(
    _: I,
  ): UpdateDockLocationActionResultData {
    const message = createBaseUpdateDockLocationActionResultData();
    return message;
  },
};

function createBaseUpdateDockLocationActionStateData(): UpdateDockLocationActionStateData {
  return {};
}

export const UpdateDockLocationActionStateData = {
  encode(_: UpdateDockLocationActionStateData, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): UpdateDockLocationActionStateData {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseUpdateDockLocationActionStateData();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): UpdateDockLocationActionStateData {
    return {};
  },

  toJSON(_: UpdateDockLocationActionStateData): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<UpdateDockLocationActionStateData>, I>>(
    base?: I,
  ): UpdateDockLocationActionStateData {
    return UpdateDockLocationActionStateData.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<UpdateDockLocationActionStateData>, I>>(
    _: I,
  ): UpdateDockLocationActionStateData {
    const message = createBaseUpdateDockLocationActionStateData();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
